import { render } from "./order_amount.vue?vue&type=template&id=5adac1dd&scoped=true"
import script from "./order_amount.vue?vue&type=script&lang=js"
export * from "./order_amount.vue?vue&type=script&lang=js"

import "./order_amount.vue?vue&type=style&index=0&id=5adac1dd&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adac1dd"]])

export default __exports__